
import $ from 'jquery'
import Qs from 'qs';
import Selector from 'vux/src/components/selector/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'
import Toast from 'vux/src/components/toast/index.vue'

export default {
name: 'Login',
components: {
Group,
Selector,
Cell,
CellBox,
Loading,
Toast,
Alert,
XButton
},
data () {
return {
phoneNum: '',
code: '',
tele_code:'CN+86',
codeTxt: '60s后重新获取',
codeDisabled: true,
biz:"86",
showAlert:false,
loginMsm:"登录失败",
show2:false,
showCodeInp:false,
loadText:"登录中",
ifgtjMem:false,
memName:"客户",
loginName:"登录",
showPositionValue: false,
toastText:"",
teleArr:[
{"intl_tele_code":"86","name":"中国","short_name":"CN"},
{"intl_tele_code":"852","name":"香港","short_name":"HK"},
{"intl_tele_code":"853","name":"澳门","short_name":"MO"},
{"intl_tele_code":"886","name":"台湾","short_name":"TW"},
{"intl_tele_code":"81","name":"日本","short_name":"JP"},
{"intl_tele_code":"82","name":"韩国","short_name":"KR"},
{"intl_tele_code":"1","name":"美国","short_name":"US"},
{"intl_tele_code":"44","name":"英国","short_name":"UK"},
{"intl_tele_code":"49","name":"德国","short_name":"DE"},
{"intl_tele_code":"33","name":"法国","short_name":"FR"},
{"intl_tele_code":"66","name":"泰国","short_name":"TH"},
{"intl_tele_code":"65","name":"新加坡","short_name":"SG"},
{"intl_tele_code":"60","name":"马来西亚","short_name":"MY"},
{"intl_tele_code":"61","name":"澳大利亚","short_name":"AU"}]
,
validation: {
phoneNumError: null,
codeError: null,
},
}
},
created() {









if(window.wx===undefined){
let script=document.createElement('script');
let head=document.getElementsByTagName('head')[0];
script.type='text/javascript';
script.charset='UTF-8';
script.src='https://res.wx.qq.com/open/js/jweixin-1.3.2.js';
head.appendChild(script);

}
},
methods: {
validPhone() {
if (this.phoneNum && this.phoneNum.toString().length>=6) {
this.codeDisabled = false;
}else {
this.codeDisabled = true;
}
},











isEmojiCharacter(substring) {
for (let i = 0; i < substring.length; i++) {
let hs = substring.charCodeAt(i);
if (0xd800 <= hs && hs <= 0xdbff) {
if (substring.length > 1) {
var ls = substring.charCodeAt(i + 1);
var uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000;
if (0x1d000 <= uc && uc <= 0x1f77f) {
return true;
}
}
} else if (substring.length > 1) {
var ls = substring.charCodeAt(i + 1);
if (ls == 0x20e3) {
return true;
}
} else {
if (0x2100 <= hs && hs <= 0x27ff) {
return true;
} else if (0x2B05 <= hs && hs <= 0x2b07) {
return true;
} else if (0x2934 <= hs && hs <= 0x2935) {
return true;
} else if (0x3297 <= hs && hs <= 0x3299) {
return true;
} else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030 ||
hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b ||
hs == 0x2b50) {
return true;
}
}
}
},
verificate(blo){
if (!this.phoneNum) {
this.toastText="请输入手机号或验证码";
this.showPositionValue = true;
return false;
}
let that=this;
if(!that.showCodeInp){
this.BM.JQajax({
url:this._Api.validate,
method:"GET",
data:{
"mobile":this.phoneNum.toString(),
},
success: function(res) {
console.log(res);
if(res.data){
that.ifgtjMem=true;
that.memName="会员";
that.loginName="登录";
}else{
that.ifgtjMem= false;
that.memName= "客户";
that.loginName="注册并登陆";
}
},
error:function(data){
}
})
}
if(blo){
let cap= new window.TencentCaptcha("2044603328",function(res){

if(res.ret === 0){
let ticket = res.ticket;
let randstr = res.randstr;

that.$vux.toast.show({
"text": '验证成功，即将为您发送验证码，请注意查收',
"time":2500,
"width":"300px",
"is-show-mask":true
})
that.BM.JQajax({
url:that._Api.safeCodeUrl,
method:"GET",
data:Qs.stringify({
"biz":that.biz,
"mobile":that.phoneNum.toString(),
"ticket": ticket,
"randstr": randstr,
}),
success: function(data) {
that.$vux.toast.show({
text: '发送成功'
})
that.codeTxt="59s后重新获取";
that.showCodeInp=true;
that.canSend=false;
let nTime = 59;
let iTime = setInterval(function () {
nTime--;
if (nTime <= 0) {
clearInterval(iTime);
that.codeTxt='重新获取';
that.canSend=true;
} else {
that.canSend=false;
that.codeTxt=nTime + "s后重新获取"
}
}, 1000);
},
error:function(data){
that.$vux.toast.show({
"text": '发送失败，请稍后重试',
"time":1000,
"width":"300px",
"is-show-mask":true
})
}
})

}
});
cap.show();
}else{
return
};











},

getCode() {
if (this.codeDisabled) {
return false
}
this.validPhone();
if (this.validation.phoneNumError && this.validation.phoneNumError !== true) {
return false
}
let nTime = 60;
this.codeDisabled = true;
this.codeTxt = '已发送(' + 59 + ')';
nTime = 59;
let iTime = setInterval(function() {
nTime--;
if (nTime <= 0) {
clearInterval(iTime);
this.codeTxt = '获取验证码';
this.codeDisabled = false;
} else {
this.codeDisabled = true;
this.codeTxt = '已发送(' + nTime + ')';
}
}.bind(this), 1000);

this.BM.JQajax({
url:this._Api.safeCodeUrl,
method:"GET",
data:{
"biz":this.biz,
"mobile":this.phoneNum.toString(),
},
success: function(data) {
},
error:function(data){
}
})
},
login(){
if (!this.phoneNum || !this.code) {
this.toastText="请输入手机号或验证码"
this.showPositionValue = true;
return false;
}
var key = 'webApp:webApp'
var authKey = Base64.encode(key);
let that =this;
this.show2=true;

this.BM.JQajax({
url:this._Api.loginUrl,
token:"Basic "+authKey,
data:{
"username":this.phoneNum.toString(),
"password":this.code.toString(),
"grant_type":"password",
"scope":"app",
"auth_type":"mobile"
},
success: function(data) {
let obj={
access_token:data.access_token,
usename:data.usename,
token_type:data.token_type,
timestamp1:Date.parse( new Date())/1000,
refreshToken: data.refresh_token
}
var ua = navigator.userAgent.toLowerCase();
that.$vux.toast.show({
text: '登录成功'
})
if(ua.match(/MicroMessenger/i)=="micromessenger") {
if(wx.miniProgram.getEnv){
that.show2=false;
wx.miniProgram.getEnv((res)=>{
if (res.miniprogram) {
wx.miniProgram.switchTab('pages/index/index');
wx.miniProgram.postMessage({ data: obj });
}
})
}else{
alert(2345);
localStorage.setItem('loginData', JSON.stringify(obj));
localStorage.setItem('refreshToken', data.refresh_token);
that.show2=false;
that.$router.push({
path: '/home'
});
}
}else{
localStorage.setItem('loginData', JSON.stringify(obj));
localStorage.setItem('refreshToken', data.refresh_token);
that.show2=false;
that.$router.push({
path: '/home'
});
}

},
error:function(data){

that.show2=false;
if(data.responseJSON.message){
that.$vux.alert.show({
title: '登录失败',
content: data.responseJSON.message,
})
}else if(data.responseJSON.error_description){
that.$vux.alert.show({
title: '登录失败',
content: data.responseJSON.error_description,
})
}else{
that.$vux.alert.show({
title: '登录失败',
content: "用户信息有误",
})
}

}
})
},

}
}



// WEBPACK FOOTER //
// ./src/pages/register.vue